/**
 *  Butterflies
 *
 *  Created by Legman on 30/05/2017.
 *
 */

import AOE from "./AOE";
import Common from "../Common";

export default class Butterflies extends AOE {
    /**
     * @param {RaceCar} owner
     */
    constructor(owner) {
        super(owner);

        /**
         * @type {PIXI.particles.Emitter}
         * @private
         */
        this._emitter = null;
    }

    init() {
        const assets = Common.assets;
        let config = assets.getJSON("particle_emitter_powerup_butterflies2");

        const holder = new PIXI.Container();
        this.addChild(holder);

        this._emitter = new PIXI.particles.Emitter(holder, [
            assets.getTexture("particles_powerup_butterfly_00"),
            assets.getTexture("particles_powerup_butterfly_01"),
            assets.getTexture("particles_powerup_butterfly_02")
        ], config);
    }

    destroy(options) {
        this._emitter.destroy();
        super.destroy(options);
    }

    update(dt) {
        super.update(dt);
        this._emitter.update(dt);
    }

    start() {
        this._emitter.emit = true;
    }

    stop() {
        this._emitter.emit = false;
    }
}